import { CONTACT_MAIL } from './constants';

export enum ErrorMessages {
  NOT_FOUND = 'Page Not found.',
  UNAUTHORIZED = 'Unauthorized: Access is denied due to invalid credentials.',
  FORBIDDEN = "Forbidden: You don't have permission to access this resource.",
  GENERIC_ERROR = 'Sorry! Something went wrong.',
  PORTAL_ERROR = 'Portal side error. Please connect with Entreda support team.',
  TIMEOUT_ERROR = 'Something went wrong, please reload this page',

  PHISHING_SUMMARY_ERROR = `No phishing summary available. Contact ${CONTACT_MAIL}`,
  PHISHING_DETAILS_ERROR = `No phishing details available. Contact ${CONTACT_MAIL}`,
  MANAGE_DEVICE_FETCH_ALL_ERROR = `No device details available. Contact ${CONTACT_MAIL}`,
  // SAT
  SAT_SUMMARY_ERROR = `No security training summary available. Contact ${CONTACT_MAIL}`,
  SAT_DETAILS_ERROR = `No security training details available. Contact ${CONTACT_MAIL}`,
  SAT_SUMMARY_REPORT_DOWNLOAD_ERROR = `No security training summary report available. Contact ${CONTACT_MAIL}`,
  //USERS
  USERS_ERROR = 'No user data available',
  // RISK ANALYTICS DASHBOARD
  CYBERRISK_SCORE_ERROR = 'Error while fetching average score.',
  DEVICE_REMEDIATION_UPDATE_ERROR = 'Failed to update remediation setting!',
  ALERT_NOTIFICATION_UPDATE_ERROR = 'Failed to update alert & Notifications!',
  DEVICE_REMEDIATION_FETCH_ERROR = 'Failed to fetch remediation settings!',
  COMPLIANCE_REPORT_FAILURE_ERROR = 'Error occurred please try again.',
  FILE_DOWNLOAD_FAILED_MESSAGE = 'File download failed',

  // Gateway and Network Errors
  NETWORK_ERROR = 'Something went wrong - please try again',
  BAD_GATEWAY_ERROR = 'Bad gateway - the server is temporarily unavailable',
  SERVICE_UNAVAILABLE_ERROR = 'Service unavailable - please try again later',
  GATEWAY_TIMEOUT_ERROR = 'Gateway timeout - the server took too long to respond',
  SERVER_ERROR = 'Server error - the service is temporarily unavailable, please try again later',

  LOGIN_UNATHORISED = 'Incorrect user name or password.',
  USER_PENDING = 'User status pending, please reset your password.',
  USER_INACTIVE = 'User has access issues. Please contact support.',
  USER_LOGIN_ISSUE = 'Something went wrong please contact support.',
  RESET_PASS_SUCCESS = 'Password reset successful, Please Login.',
  OTP_SENT = 'OTP sent successfully. Please check registerd email.',
  OTP_VERIFY_SUCCESS = 'OTP verified successfully.',
  INVALID_OTP = 'Invalid OTP provided, please try again.',
  INVALID_USER = 'User not found with the given username.',
  RESET_PWD_ERROR = 'User token is not valid. Please try with a valid token.'
}
